module.exports = __webpack_public_path__ + "static/media/sidebar-2.310509c9.jpg";